import React from 'react';
import '../template-file-css/document-file-template.css';


export const ACTS_Cats = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='ACTS_Cats' className='file-pdf-document'>
            <div className='file-template'>




                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Child's Name:</span></td>
                        <td className='w-375'><span className='eleHeader'>Caregiver's Name:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtChildsName" name="txtChildsName" className='add-only' /></td>
                        <td className='w-375'>
                            <input type="text" id="txtCaregiversName" name="txtCaregiversName" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Provider's Name:</span></td>
                        <td className='w-375'><span className='eleHeader'>Assessment Date:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtProvider" name="txtProvider" className='add-only' /></td>
                        <td className='w-375'>
                            <input type="date" id="txtAssessmentDate" name="txtAssessmentDate" className='add-only' /></td>
                    </tr>
                </table>


                <p className='w-750'>
                    <b>Total Severity Score
                        <br />
                        Ages 7-17
                    </b>
                </p>
                <ul>
                    <li>Probable PTSD CATS= 21+</li>
                    <li>Mild/Moderate CATS = 16-20</li>
                    <li>Not Elevated CATS = 0-14</li>
                </ul>
                <p className='w-750'>
                    <b>Total Severity Score
                        <br />
                        Ages 3-6
                    </b>
                </p>
                <ul>
                    <li>Probable PTSD CATS= 16+</li>
                    <li>Mild/Moderate CATS = 12-15</li>
                    <li>Not Elevated CATS = 0-11</li>
                </ul>

                <p className='w-750'>
                    <center>
                        <b>CAREGIVER Report</b>
                    </center>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Trauma Exposure:</span></td>
                        <td className='w-375'><span className='eleHeader'>Total PTSD Severity Score:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtTraumaExposure" name="txtTraumaExposure" className='add-only' /></td>
                        <td className='w-375'>
                            <input placeholder="Add ALL items, 1-20" type="text" id="txtTotalPtsd" name="txtTotalPtsd" className='add-only' /></td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-350'><span className='eleHeader'>Criteria</span></td>
                        <td className='w-100'>
                            <span className='eleHeader'># of Symptoms</span>
                            <span className='small'>(Only count items rated 2 or 3)</span>
                        </td>
                        <td className='w-150'><span className='eleHeader'># Symptoms Required</span></td>
                        <td className='w-150'><span className='eleHeader'>DSM-5 Criteria Met?</span></td>
                    </tr>
                    <tr>
                        <td className='w-350'>
                            <b>Re-experiencing</b> Items 1-5

                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtSymptoms_1" name="txtSymptoms_1" className='add-only' /></td>
                        <td className='w-150'>
                            <center>1+</center>
                        </td>
                        <td className='w-150'>
                            <input type="radio" id="rbCriteriaYes_1" name="rbCriteria_1" className='add-only' value="Yes" /> Yes &nbsp;
                            <input type="radio" id="rbCriteriaNo_1" name="rbCriteria_1" className='add-only' value="No" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-350'>
                            <b>Avoidance</b> Items 6-7

                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtSymptoms_2" name="txtSymptoms_2" className='add-only' /></td>
                        <td className='w-150'>
                            <center>1+</center>
                        </td>
                        <td className='w-150'>
                            <input type="radio" id="rbCriteriaYes_2" name="rbCriteria_2" className='add-only' value="Yes" /> Yes &nbsp;
                            <input type="radio" id="rbCriteriaNo_2" name="rbCriteria_2" className='add-only' value="No" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-350'>
                            <b>Negative Mood/ Cognitions</b> Items 8-14

                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtSymptoms_3" name="txtSymptoms_3" className='add-only' /></td>
                        <td className='w-150'>
                            <center>2+</center>
                        </td>
                        <td className='w-150'>
                            <input type="radio" id="rbCriteriaYes_3" name="rbCriteria_3" className='add-only' value="Yes" /> Yes &nbsp;
                            <input type="radio" id="rbCriteriaNo_3" name="rbCriteria_3" className='add-only' value="No" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-350'>
                            <b>Arousal</b> Items 15-20
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtSymptoms_4" name="txtSymptoms_4" className='add-only' /></td>
                        <td className='w-150'>
                            <center>2+</center>
                        </td>
                        <td className='w-150'>
                            <input type="radio" id="rbCriteriaYes_4" name="rbCriteria_4" className='add-only' value="Yes" /> Yes &nbsp;
                            <input type="radio" id="rbCriteriaNo_4" name="rbCriteria_4" className='add-only' value="No" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-350'>
                            <b>Functional Impairment
                            </b>Set of 1-5 Yes/No Questions
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtSymptoms_5" name="txtSymptoms_5" className='add-only' /></td>
                        <td className='w-150'>
                            <center>1+</center>
                        </td>
                        <td className='w-150'>
                            <input type="radio" id="rbCriteriaYes_5" name="rbCriteria_5" className='add-only' value="Yes" /> Yes &nbsp;
                            <input type="radio" id="rbCriteriaNo_5" name="rbCriteria_5" className='add-only' value="No" /> No
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='small'>*Age 6 & Under - Only need 1 symptom of avoidance OR negative mood/cognitions</span>
                </p>

                <p className='w-750'>
                    <center>
                        <b>CHILD Report</b>
                    </center>
                </p>

                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Trauma Exposure:</span></td>
                        <td className='w-375'><span className='eleHeader'>Total PTSD Severity Score:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtChildTraumaExposure" name="txtChildTraumaExposure" className='add-only' /></td>
                        <td className='w-375'>
                            <input placeholder="Add ALL items, 1-20" type="text" id="txtChildTotalPtsd" name="txtChildTotalPtsd" className='add-only' /></td>
                    </tr>
                </table>




                <table>
                    <tr>
                        <td className='w-350'><span className='eleHeader'>Criteria</span></td>
                        <td className='w-100'>
                            <span className='eleHeader'># of Symptoms</span>
                            <span className='small'>(Only count items rated 2 or 3)</span>
                        </td>
                        <td className='w-150'><span className='eleHeader'># Symptoms Required</span></td>
                        <td className='w-150'><span className='eleHeader'>DSM-5 Criteria Met?</span></td>
                    </tr>
                    <tr>
                        <td className='w-350'>
                            <b>Re-experiencing</b> Items 1-5

                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtChildSymptoms_1" name="txtChildSymptoms_1" className='add-only' /></td>
                        <td className='w-150'>
                            <center>1+</center>
                        </td>
                        <td className='w-150'>
                            <input type="radio" id="rbChildCriteriaYes_1" name="rbChildCriteria_1" className='add-only' value="Yes" /> Yes &nbsp;
                            <input type="radio" id="rbChildCriteriaNo_1" name="rbChildCriteria_1" className='add-only' value="No" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-350'>
                            <b>Avoidance</b> Items 6-7

                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtChildSymptoms_2" name="txtChildSymptoms_2" className='add-only' /></td>
                        <td className='w-150'>
                            <center>1+</center>
                        </td>
                        <td className='w-150'>
                            <input type="radio" id="rbChildCriteriaYes_2" name="rbChildCriteria_2" className='add-only' value="Yes" /> Yes &nbsp;
                            <input type="radio" id="rbChildCriteriaNo_2" name="rbChildCriteria_2" className='add-only' value="No" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-350'>
                            <b>Negative Mood/ Cognitions</b> Items 8-14

                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtChildSymptoms_3" name="txtChildSymptoms_3" className='add-only' /></td>
                        <td className='w-150'>
                            <center>2+</center>
                        </td>
                        <td className='w-150'>
                            <input type="radio" id="rbChildCriteriaYes_3" name="rbChildCriteria_3" className='add-only' value="Yes" /> Yes &nbsp;
                            <input type="radio" id="rbChildCriteriaNo_3" name="rbChildCriteria_3" className='add-only' value="No" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-350'>
                            <b>Arousal</b> Items 15-20
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtChildSymptoms_4" name="txtChildSymptoms_4" className='add-only' /></td>
                        <td className='w-150'>
                            <center>2+</center>
                        </td>
                        <td className='w-150'>
                            <input type="radio" id="rbChildCriteriaYes_4" name="rbChildCriteria_4" className='add-only' value="Yes" /> Yes &nbsp;
                            <input type="radio" id="rbChildCriteriaNo_4" name="rbChildCriteria_4" className='add-only' value="No" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-350'>
                            <b>Functional Impairment
                            </b>Set of 1-5 Yes/No Questions
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtChildSymptoms_5" name="txtChildSymptoms_5" className='add-only' /></td>
                        <td className='w-150'>
                            <center>1+</center>
                        </td>
                        <td className='w-150'>
                            <input type="radio" id="rbChildCriteriaYes_5" name="rbChildCriteria_5" className='add-only' value="Yes" /> Yes &nbsp;
                            <input type="radio" id="rbChildCriteriaNo_5" name="rbChildCriteria_5" className='add-only' value="No" /> No
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='small'>*Age 6 & Under - Only need 1 symptom of avoidance OR negative mood/cognitions</span>
                </p>






            </div>
        </form>

    )
}  
